import React from "react";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Tooltip } from "@mui/material";
import { allOrderList } from "../../Datas/ProductDatas/OrderData";
import FakeTableComponent from "../../Components/FakeTableComponent/FakeTableComponent";
import NoItemFound from "../../Components/SiteComponants/NoItemFound";
import moment from "moment/moment";
import { useAuthContext } from "../../Contexts/AuthContext";
import { notify } from "../../Datas/Functions/toast";
import { isIncluded } from "../../Datas/Functions/shareFunctions";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import { TitleSetup } from "../../Datas/Functions/titleSetup";
import MenuButton from "../../Components/SiteComponants/MenuButton";

const OrderList = (meta) => {
  // setting up title of this page
  TitleSetup({ ...meta });
  //********** */
  const { user, isAdmin } = useAuthContext();
  const [searchedText, setSearchedText] = useState("");
  const [selectedItem, setSelectedItem] = useState("order_trxid");
  const [datalist, setDatalist] = useState([]);

  const column = [
    {
      name: "TrxID",
      selector: (row) => (
        <span
          onClick={() => {
            navigator.clipboard.writeText(row.order_trxid);
            notify("Trx ID Copied to clipboard", "", "success");
          }}
        >
          {row.order_trxid} <i className="fas fa-copy    "></i>
        </span>
      ),
    },
    {
      name: "Payment Account",
      selector: (row) => (
        <Tooltip title={row.order_payment_method} arrow>
          <span
            onClick={() => {
              navigator.clipboard.writeText(row.order_account);
              notify("Payment Account Copied to clipboard", "", "success");
            }}
          >
            {row.order_account}
          </span>
        </Tooltip>
      ),
    },
    {
      name: "Purchased Item",
      selector: (row) => (
        <div>
          <p>
            {row.order_name} - ({row.order_price} &#2547;)
          </p>
        </div>
      ),
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: "product_name",
    },
    {
      name: "Purchased",
      selector: (row) => (
        <span>{moment(parseInt(row.created_at)).fromNow()}</span>
      ),
      sortable: "created_at",
    },
    {
      name: isAdmin ? "Detail Link" : "",
      selector: (row) => (
        <Link className="nav-item active inline-block" to={"" + row.id}>
          View Details
        </Link>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div>
          {isAdmin ? (
            <div>
              {isIncluded(row.order_status, "proc") ? (
                <div className="flex flex-wrap">
                  <MenuButton text={"Action"}>
                    <ul className="cursor-pointer ">
                      <li
                        className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
                        onClick={() => handleOptionClick("Completed", row.id)}
                      >
                        <span>
                          <i
                            className="fa fa-check text-green-500"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span>Complete</span>
                      </li>
                      <li
                        className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
                        onClick={() => handleOptionClick("Cancelled", row.id)}
                      >
                        <span>
                          <i
                            className="fa fa-times text-red-500"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span>Cancel</span>
                      </li>
                    </ul>
                  </MenuButton>
                </div>
              ) : (
                <span className="font-semibold">{row.order_status}</span>
              )}
            </div>
          ) : (
            <span
              className={`font-bold ${
                row.order_status === "Completed"
                  ? "text-green-600"
                  : row.order_status === "Canceled"
                  ? "text-red-600"
                  : "text-yellow-700"
              }`}
            >
              {row.order_status}
            </span>
          )}
        </div>
      ),
      sortable: "order_status",
    },
  ];

  const selectionOption = [
    {
      title: "Trx ID",
      value: "order_trxid",
    },
    {
      title: "Product Name",
      value: "product_name",
    },
    {
      title: "Order Status",
      value: "order_status",
    },
    {
      title: "Account Number",
      value: "order_account",
    },
    {
      title: isAdmin ? "Customer Name" : "",
      value: isAdmin ? "customer_name" : "",
    },
  ];

  useEffect(() => {
    // admin or user check logic here
    const newDatalist = allOrderList.filter(
      (ord) => ord.customer_id === user?.id || isAdmin
    );
    setDatalist(newDatalist);
  }, [user, isAdmin]);

  useEffect(() => {
    // search by options on the top of the table
    const newDatalist = allOrderList
      .filter((ord) => ord.customer_id === user?.id || isAdmin)
      .filter(
        (data) =>
          isIncluded(String(data[selectedItem]), searchedText) ||
          searchedText === ""
      )
      .sort((a, b) => {
        if (isIncluded(a.order_status, "proc")) {
          return -1;
        } else if (isIncluded(b.order_status, "proc")) {
          return 1;
        } else return 0;
      });
    setDatalist(newDatalist);
  }, [searchedText, selectedItem, isAdmin, user]);

  // handler function
  const handleOptionClick = (option, id) => {
    console.log(`Selected option: ${option}`);
  };
  return (
    <div className="w-full mx-2 md:container md:mx-auto">
      <SectionHeader heading={"Order List"} />
      <BreadCrumbs texts={["Dashboard", "Orderlist"]} />
      <FakeTableComponent
        datalist={datalist}
        column={column}
        pagination
        cursorPointer
        rowPerPageItems={[5, 10, 15, 20, 30, 40, 50, 100]}
        tableScroll
        tableScrollHeight={"500px"}
        tableHeaderComponent={
          <h2 className="text-4xl text-center font-semibold">Order List</h2>
        }
        filterComponents={[
          <div className="border-2 rounded-sm my-2 mx-3">
            <select
              className="px-3 py-2 h-full sm:w-auto w-full sm:border-r-2 sm:border-b-0 border-b focus:outline-0 "
              onChange={(e) => setSelectedItem(e.target.value)}
              defaultValue={selectedItem}
            >
              {selectionOption.map((opt, i) => {
                return (
                  opt.title && (
                    <option key={i} value={opt.value}>
                      Seacrh by {opt.title}
                    </option>
                  )
                );
              })}
            </select>
            <input
              onChange={(e) => setSearchedText(e.target.value)}
              className="px-3 py-2 w-40 sm:w-52  focus:outline-0"
              placeholder={`Search...🔎`}
            />
          </div>,
        ]}
        nodataComponent={<NoItemFound msg={"No data found"} />}
      />
    </div>
  );
};

export default OrderList;
